import React from 'react';
import * as Styled from './MediaPreviewIcon.styled';

const MediaPreviewIcon = (props) => {
  return (
    <Styled.Wrapper className={props.className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="29.646"
        height="22.287"
        viewBox="0 0 29.646 22.287"
      >
        <path
          fill="#b3b3b3"
          d="M439.359,523.795H416.411a3.349,3.349,0,0,0-3.35,3.348v15.591a3.349,3.349,0,0,0,3.35,3.348h22.948a3.349,3.349,0,0,0,3.348-3.348V527.143A3.349,3.349,0,0,0,439.359,523.795Zm-5.878,11.849-8.8,4.548a.8.8,0,0,1-1.16-.706v-9.1a.794.794,0,0,1,1.16-.706l8.8,4.548A.794.794,0,0,1,433.481,535.644Z"
          transform="translate(-413.061 -523.795)"
        />
      </svg>
    </Styled.Wrapper>
  );
};

export default MediaPreviewIcon;
